import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {TerceroUPPasarelaAdjunto, TerceroUPPasarelaAdjuntoVersion} from '../_models/tercero-up-pasarela-adjunto';

@Injectable({
  providedIn: 'root'
})
export class TerceroUpPasarelaAdjuntoService {
  private rutServicio = AppSettings.rutServiciosTER + '/api/tercerosUPPasarelasAdjuntos';
  private rutServicioSolicitudPasarela = AppSettings.rutServiciosAPL + '/api/solicitudesUCUPPasarelasAdjuntos';

  constructor(private httClient: HttpClient) {
  }

  listAdjuntos(idTerceroUPPasarela: string) {
    return this.httClient.get(`${this.rutServicio}/listAdjuntos/${idTerceroUPPasarela}`).pipe(map(res => res as TerceroUPPasarelaAdjunto[]));
  }

  crearAdjuntoVersion(registro: Partial<TerceroUPPasarelaAdjunto>) {
    return this.httClient.post(`${this.rutServicio}/createPasareleVersion`, registro).pipe(map(res => res as TerceroUPPasarelaAdjuntoVersion));
  }

  inhabilitarAdjunto(registro: Partial<TerceroUPPasarelaAdjunto>) {
    return this.httClient.post(this.rutServicio, registro);
  }

  guardarAdjuntosSolicitudBulk(registros: Partial<TerceroUPPasarelaAdjunto>[]) {
    return this.httClient
      .post(`${this.rutServicioSolicitudPasarela}/guardarAdjuntos/bulk`, registros)
      .pipe(map(res => res as TerceroUPPasarelaAdjunto[]));
  }

  guardarAdjuntosTerceroBulk(registros: Partial<TerceroUPPasarelaAdjunto>[]) {
    return this.httClient
      .post(`${this.rutServicio}/bulk`, registros)
      .pipe(map(res => res as TerceroUPPasarelaAdjunto[]));
  }
}
